import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { I18nProvider } from './i18n.tsx';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root nicht gefunden');

/**
 * Erst das Session-Cookie holen, dann rendern.
 *
 * Der Socket verbindet sich beim ersten Render. Ohne diesen Schritt
 * kann er den Handshake ausfuehren, bevor der Browser ein
 * Session-Cookie besitzt -- dann rennen zwei Requests um das Setzen des
 * Cookies, und der Socket landet moeglicherweise auf einer Session, die
 * gleich darauf ueberschrieben wird. Ergebnis: HTTP-seitig ist Spotify
 * verknuepft, der Socket weiss aber nichts davon.
 *
 * Ein Fehlschlag ist unkritisch: der Server legt beim Handshake
 * ebenfalls eine Session an.
 */
async function bootstrap(): Promise<void> {
  try {
    await fetch('/api/auth/status', { credentials: 'same-origin' });
  } catch {
    // Server nicht erreichbar -- die UI zeigt das ueber den
    // Verbindungsstatus des Sockets an.
  }

  createRoot(container as HTMLElement).render(
    <StrictMode>
      <I18nProvider>
        <App />
      </I18nProvider>
    </StrictMode>,
  );
}

void bootstrap();
